import React from "react";
import { useFetchUserEquipmentsQuery } from "../../../store";
import Loading from "../../../components/shared/Loading";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import { alpha } from "@mui/material/styles";

const Equipments = () => {
  const { data, isLoading } = useFetchUserEquipmentsQuery();
  if (isLoading) return <Loading isLoading={isLoading} />;

  return (
    data?.data.length !== 0 && (
      <Box sx={{ py: 4, width: "100%" }}>
        <Typography
          variant="h4"
          sx={{
            mb: 2,
            fontWeight: 700,
            textAlign: "center",
            color: "primary.main",
            letterSpacing: 1,
          }}
        >
          Zimmetlerim
        </Typography>
        <Divider sx={{ mb: 3, mx: "auto", width: { xs: "80%", md: "40%" } }} />
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "1fr 1fr 1fr 1fr",
            },
            gap: 4,
            width: "100%",
            mt: 2,
            px: { xs: 1, sm: 2, md: 4 },
          }}
        >
          {data?.data.map((item, index) => (
            <Card
              key={index}
              sx={{
                p: 3,
                borderRadius: 4,
                boxShadow: 6,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                minHeight: 220,
                bgcolor: (theme) => alpha(theme.palette.primary.light, 0.12),
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-6px) scale(1.03)",
                  boxShadow: 12,
                  bgcolor: (theme) => alpha(theme.palette.primary.light, 0.22),
                },
              }}
            >
              <Box
                sx={{
                  bgcolor: "primary.main",
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 2,
                  boxShadow: 2,
                }}
              >
                <DevicesOtherIcon sx={{ color: "#fff", fontSize: 36 }} />
              </Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  textAlign: "center",
                  mb: 1,
                  color: "primary.dark",
                  letterSpacing: 0.5,
                }}
              >
                {item.categoryName}
              </Typography>
              <Divider sx={{ width: "100%", mb: 2 }} />
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  px: 1,
                  gap: 1,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    fontSize: "1.15rem",
                    color: "text.primary",
                  }}
                >
                  <span style={{ color: "#8B1A1A" }}>Marka:</span>{" "}
                  {item.brandName}
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    fontSize: "1.15rem",
                    color: "text.primary",
                  }}
                >
                  <span style={{ color: "#8B1A1A" }}>Model:</span>{" "}
                  {item.modelName}
                </Typography>
              </Box>
            </Card>
          ))}
        </Box>
      </Box>
    )
  );
};

export default Equipments;
